<template>
  <b-container fluid class="hero-section bg-primary py-5 px-4">
    <div
      class="d-flex flex-column flex-md-row align-items-center justify-content-between position-relative overflow-hidden hero-inner mx-auto"
      :class="{'flex-column': isSmallScreen}"
    >

      <!-- Text -->
      <div class="text-center text-md-left z-index-1 mb-4 mb-md-0 hero-content-text">
        <h5 class="hero-label text-secondary mb-2">{{ $t('concept.cta.label') }}</h5>
        <h3 class="hero-title text-secondary mb-2">{{ $t('concept.cta.title') }}</h3>
        <p class="hero-subtitle mb-0">{{ $t('concept.cta.subtitle') }}</p>
      </div>

      <!-- Buttons -->
      <div class="d-flex flex-column flex-sm-row gap-3 hero-content-buttons z-index-1">
        <b-button variant="gold" class="hero-btn-primary bg-secondary text-primary mb-2 mb-sm-0">
          {{ $t('concept.cta.trial') }}
        </b-button>
        <b-button variant="outline-gold" class="hero-btn-secondary text-secondary">
          {{ $t('concept.cta.demo') }}
        </b-button>
      </div>

      <!-- Decorative circles -->
      <div class="decor-circle decor-circle-1"></div>
      <div class="decor-circle decor-circle-2"></div>

    </div>
  </b-container>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      isSmallScreen: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth < 768;
    },
  },
};
</script>

<style scoped>
.hero-section {
  border-bottom: 8px solid #c9a24d;
  position: relative;
  border-radius: 0;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

body.dark .hero-section {
  background-color: #000000;
}

/* Hero Inner: max-width */
.hero-inner {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 767.98px) {
  .hero-inner {
    max-width: 100%;
    flex-direction: column !important;
  }
}

/* Text */
.hero-label {
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.hero-title {
  font-size: 2rem;
  font-weight: 700;
  font-family: 'Display', sans-serif;
}

.hero-subtitle {
  color: #b0b0b0;
  font-weight: 300;
  letter-spacing: 1px;
}

/* Buttons container: push buttons to right with space-between */
.hero-content-buttons {
  margin-left: auto;
}

/* Buttons */
.hero-btn-primary {
  min-width: 180px;
  height: 56px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
}

.hero-btn-primary:hover {
  background-color: #d4b35d;
  transform: scale(1.05);
}

.hero-btn-secondary {
  min-width: 180px;
  height: 56px;
  background-color: transparent;
  border: 1px solid rgba(201, 162, 77, 0.3);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  transition: all 0.3s ease;
}

.hero-btn-secondary:hover {
  background-color: rgba(201, 162, 77, 0.1);
}

/* Decorative circles */
.decor-circle {
  position: absolute;
  width: 192px;
  height: 192px;
  border-radius: 50%;
  border: 1px solid rgba(201, 162, 77, 0.1);
}

.decor-circle-1 {
  bottom: -40px;
  right: -40px;
  z-index: 0;
}

.decor-circle-2 {
  bottom: -20px;
  right: -20px;
  z-index: 0;
}

/* Flex gap replacement */
.gap-3 {
  gap: 1rem !important;
}
</style>
